import { Schema } from '@cfworker/json-schema';

export const uuid_schema: Schema = {
  type: 'string',
  pattern: '^[0-9a-f]{8}-(?:[0-9a-f]{4}-){3}[0-9a-f]{12}$' // ensure lower-case
};

export const uuid_lookup_item_schema: Schema = {
  type: 'object',
  additionalProperties: false,
  required: ['id', 'title'],
  properties: {
    id: uuid_schema,
    title: {
      type: 'string',
      minLength: 1,
      maxLength: 250
    }
  }
};
